<template>
	<div>
		<h1>Variables</h1>
		<div id="jsoneditor"></div>
		<b-button @click="update">Mettre à jour</b-button>
	</div>
</template>

<script>
	import client from "../services/client.js";
	import users from "../services/users.js";
	import store from "../store";

	import { JSONEditor } from "@json-editor/json-editor";

	export default {
		name: "client_var",
		components: {},
		data() {
			return {
				client_var: {},
			};
		},
		methods: {
			update: async function () {
				console.log("update");
				await client.put(null, null, null, this.client_var);
			},
		},
		mounted: async function () {
			var self = this;

			if (store.state.user.rules && !store.state.user.rules.client_var) {
				this.$router.push({ name: "profile" });
			}

			let response = await users.getSelf(true);
			this.client = response.client;

			if (this.client && this.client.details && this.client.details.var)
				this.client_var = this.client.details.var;

			const element = document.getElementById("jsoneditor");
			var schema = {
				title: "Variables client",
				type: "object",
			};

			this.editor = new JSONEditor(element, {
				schema: schema,
				theme: "bootstrap4",
				iconlib: "fontawesome5",
				object_background: "",
			});

			await new Promise((resolve, reject) => {
				self.editor.on("ready", function () {
					if (resolve) resolve();
				});
			});

			this.editor.on("change", function () {
				self.client_var = self.editor.getValue();
			});

			this.editor.setValue(this.client_var);
		},
	};
</script>

<style scoped>
	.input-group > .input-group-prepend {
		flex: 0 0 20%;
	}
	.input-group .input-group-text {
		width: 100%;
	}
</style>
